import {HTMLAttributes, useEffect, useRef, RefObject } from "react"
import X from '../../public/icons/x.svg';
import { useModalFocus } from '../../lib/useModalFocus';

interface ModalProps extends HTMLAttributes<HTMLElement> {
  onClose?: Function
  isOpen?: boolean
  triggerRef?: RefObject<HTMLElement> // Element that opened the modal
}

function Modal({onClose, children, isOpen = true, triggerRef} : ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  
  // Use the custom hook for focus management
  useModalFocus({
    isOpen,
    onClose: onClose ? () => onClose() : undefined,
    modalRef: modalRef as React.RefObject<HTMLElement>,
    triggerRef
  });

  useEffect(() => {
    document.body.classList.add('body--modal-active');
    return () => {
      document.body.classList.remove('body--modal-active')
    };
  }, []);
  
  return (
    <>
      <div className="modal" ref={modalRef}>
        <div className="modal__content">
          { onClose && <button className="modal__content__close" onClick={(e) => onClose(e)}><X /></button>}
          {children}
        </div>
      </div>
      <div className="modal-backdrop active"></div>
    </>
  )
}

export default Modal